// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JoVCMwmKXjmRv3cDepGv{display:flex;justify-content:center}.JWqCoBOTUcK3U_QwTTFZ{display:flex;justify-content:center;align-items:center}.iqX4x255_t1ehwI_SOLk .modal-content{padding:1rem 3rem 2rem 3rem}.F63jFYsBuG1ghSLUglxR{text-align:center}.F63jFYsBuG1ghSLUglxR p{padding-bottom:1rem}.F63jFYsBuG1ghSLUglxR a{color:#005ea8}.h3d6eHPnQynNL8JExE79{font-family:var(--font1);font-weight:bold}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"socialSignButtons": "JoVCMwmKXjmRv3cDepGv",
	"googleButton": "JWqCoBOTUcK3U_QwTTFZ",
	"facebookAccountRecoveryModal": "iqX4x255_t1ehwI_SOLk",
	"facebookAccountRecovery": "F63jFYsBuG1ghSLUglxR",
	"boldParagraph": "h3d6eHPnQynNL8JExE79"
};
export default ___CSS_LOADER_EXPORT___;
